// أغلفة الإذاعات.
//
// كان هذا الملف يحمل 25 رابط صورة من Unsplash تُستخدم كأغلفة. أُزيلت كلها:
// تتعطل دون إنترنت، وتعتمد على طرف ثالث، وبلا إذن استخدام موثّق، وبعضها
// غير مناسب للمحتوى أصلاً (أبو الهول والأهرامات كغلاف لإذاعة قرآن).
//
// البديل: زخرفة هندسية إسلامية تُولَّد محلياً من معرّف الإذاعة
// (انظر components/StationArtwork.jsx). والأدمن يستطيع دائماً لصق رابط
// شعار حقيقي في حقل `logo` فيُعرض بدل الزخرفة.

/** بذور تعطي زخارف مختلفة — تُعرض في نافذة اختيار الغلاف. */
export const ARTWORK_PRESETS = [
  { id: 'emerald', title: 'زمردي', seed: 'preset-emerald-0' },
  { id: 'gold', title: 'ذهبي', seed: 'preset-gold-1' },
  { id: 'turquoise', title: 'فيروزي', seed: 'preset-turquoise-2' },
  { id: 'violet', title: 'بنفسجي', seed: 'preset-violet-3' },
  { id: 'ruby', title: 'عقيقي', seed: 'preset-ruby-4' },
  { id: 'teal', title: 'تركوازي', seed: 'preset-teal-5' },
  { id: 'azure', title: 'لازوردي', seed: 'preset-azure-6' },
  { id: 'amber', title: 'عنبري', seed: 'preset-amber-7' },
];

/**
 * لا يوجد غلاف افتراضي بعد الآن: غياب `logo` يعني رسم الزخرفة المولَّدة،
 * وهي دائماً متاحة ولا تحتاج شبكة.
 */
export const DEFAULT_PLACEHOLDER_IMAGE = null;

/** أُبقي للتوافق مع الكود القديم؛ المعرض صار مبنياً على الزخارف. */
export const ISLAMIC_IMAGES_GALLERY = ARTWORK_PRESETS;
